import { ApiService as api } from "../Services/APIService";
import { TemplateService } from "../Services/TemplateService";
import { UtilService as util } from "../Services/UtilService";

const groupCardTemplate = 'GroupCard';
const groupModalTemplate = 'GroupModal';

export class GroupsModule {
    static async Init() {

        DEBUG && console.info('*--> Groups Module Init');

        var elements = document.querySelectorAll('[data-component="groupCards"]');

        elements.forEach(element => {
            var congregationId = element.getAttribute('data-congregationId');
            var search = element.getAttribute('data-search');
            var loadGroupId = element.getAttribute('data-groupid');
            var tag = element.getAttribute('data-tag');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Congregation:            ${congregationId}`);
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Search:                  ${search}`);
            DEBUG && console.info(`Group ID:                ${loadGroupId}`);
            DEBUG && console.info(`Tag:                     ${tag}`);
            DEBUG && console.info('**************************************************');            

            this.AddModalEvents();
            this.GetGroupCards(congregationId, element, search, loadGroupId, tag);
        });
    }

    //
    // Init: DOM - Add Group Cards
    //
    static async GetGroupCards(congregationId, element, search, loadGroupId, tag) {
        var data = await this.GetGroups(congregationId);
        /*var tags = await this.GetGroupTags(congregationId);*/

        DEBUG && console.info('*--> Group Data Loaded');
        var groupData = { "groups": data.Groups, "tags": data.Tags };
        DEBUG && console.info(groupData);
        
        sessionStorage.setItem("groupData", JSON.stringify(groupData));
       
        var content = await TemplateService.GetRenderedTemplate(groupCardTemplate, groupData); 

        element.innerHTML = content;        

        this.AddSearchEvents();

        if (search) {
            document.getElementById("groupSearch").value = search;
            this.SearchGroups();
        }

        if (tag) {
            var tagSearch = document.getElementById("tagSearch");
            tagSearch.value = tag;
            this.TagSearchGroups();
        }

        if (loadGroupId) {
            this.LoadGroupModal(loadGroupId, true);
        }
    }


    //
    // Init: Search Events
    //
    static AddSearchEvents() {
        DEBUG && console.info('*--> Init Group Search');

        var btnGroupSearch = document.getElementById("btnGroupSearch");
        var groupSearch = document.getElementById("groupSearch");
        var tagSearch = document.getElementById("tagSearch");
        const btnGroupClearSearch = document.getElementById("btnGroupClearSearch");

        let that = this;

        btnGroupSearch.addEventListener('click', function () {
            DEBUG && console.info('*--> Group Search Clicked');
            that.PreSearchCleanUp();
            that.SearchGroups();
        });

        btnGroupClearSearch.addEventListener('click', function () {
            groupSearch.value = "";
            that.PreSearchCleanUp();
            that.SearchGroups();
        });

        groupSearch.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                DEBUG && console.info('*--> Group Search Enter Key');
                that.PreSearchCleanUp();
                that.SearchGroups();
            }
        });

        groupSearch.addEventListener('input', function (event) {
            const searchText = event.target.value;
            if (searchText === '') {
                // The search field has been cleared
                DEBUG && console.log('*==> GroupSearch: Search field cleared');                
                that.PreSearchCleanUp();
                // Handle the cleared search field event
                that.SearchGroups();
            }
        });


        // Wire up tags to Search Click
        let tagElements = document.querySelectorAll('[data-tag="true"]');

        tagElements.forEach((tag) => {
            tag.addEventListener('click', function () {
                tagSearch.value = this.getAttribute('data-id');
                groupSearch.value = this.getAttribute('data-t');
                util.addUpdatedUrlState(`tag=${tagSearch.value}`);
                that.PreSearchCleanUp();
                that.TagSearchGroups();
            });
        });
    }

    static PreSearchCleanUp() {
        var elements = document.querySelectorAll(`[data-tag="true"]`);

        // Loop through the elements and add a style
        elements.forEach(function (element) {

            if (element.classList.contains('bg-primary')) {
                element.classList.add('bg-secondary');
                element.classList.remove('bg-primary');
            }
        });
    }

    //
    // Search Function
    //
    static SearchGroups() {
        var searchTerm = document.getElementById("groupSearch").value;
        var groupData = JSON.parse(sessionStorage.getItem("groupData"));

        util.addUpdatedUrlState(`search=${searchTerm}`);

        let newArray = groupData.groups.filter(function (el) {
            return el.Group_Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (el.Description && el.Description.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (el._Group_Focus && el._Group_Focus.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (el._Meeting_Day && el._Meeting_Day.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (el._Life_Stage && el._Life_Stage.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (el._Ministry && el._Ministry.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (el.TagItems && el.TagItems.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (el._Meeting_Duration && el._Meeting_Duration.toLowerCase().includes(searchTerm.toLowerCase()));
            }
        );

        DEBUG && console.info('*--> Group Search Results');
        DEBUG && console.log(newArray);

        this.UpdateVisibleGroups(newArray, searchTerm);
    }

    static TagSearchGroups() {
        var searchTerm = document.getElementById("groupSearch").value;
        var tagSearchTerm = document.getElementById("tagSearch").value;

        var groupData = JSON.parse(sessionStorage.getItem("groupData"));

        // Regex to match the exact string ignoring case
        let searchTermRegex = new RegExp(`^${tagSearchTerm}$`, 'i');

        let newArray = groupData.groups.filter(function (el) {
            let matchFound = false;
            if (el.TagList && Array.isArray(el.TagList)) {
                matchFound = el.TagList.some(function (tag) {
                    return searchTermRegex.test(tag.TagKey);
                });
            }
            return matchFound;
        });

        DEBUG && console.info('*--> Group Tag Search Results');
        DEBUG && console.log(newArray);

        this.UpdateVisibleGroups(newArray, tagSearchTerm);

        // Highlist the Tags for Selected Tag
        var elements = document.querySelectorAll(`[data-id="${tagSearchTerm}"]`);

        // Loop through the elements and add a style
        elements.forEach(function (element) {
            // Example: adding a red border to each element
            element.classList.remove('bg-secondary');
            element.classList.add('bg-primary');
        });
    }

    static UpdateVisibleGroups(newArray, searchTerm) {
        // Hide all Group Cards
        var groupCards = document.querySelectorAll('.group-card-wrapper');
        groupCards.forEach((gc) => {
            gc.style.display = 'none';
        });

        // Show NewArray Cards
        newArray.forEach((group) => {
            var gc = document.querySelector(`[data-groupid="${group.Group_ID}"]`);
            if (gc) {
                gc.style.display = 'block';
            }
        });

        // Update Group Count
        var groupCountElement = document.getElementById('groupCount');
        groupCountElement.textContent = `${newArray.length} Groups Found`;

        // show or hide clear button
        const panelClearSearch = document.getElementById("panelClearSearch");
        if (searchTerm.length > 0) {
            panelClearSearch.style.display = "block";
        }
        else {
            panelClearSearch.style.display = "none";
        }
    }


    //
    // Init: Add Modal Listener
    //
    static AddModalEvents() {
        DEBUG && console.info('*--> Init Group Modal');
        const element = document.getElementById('groupFocusModal');
        element.addEventListener('show.bs.modal', (evt) => {
            DEBUG && console.log('Modal Called');  

            // Wrap Load Group Modal in Try / Catch to handle Manual Open
            try {
                this.LoadGroupModal(evt.relatedTarget.getAttribute('data-id'));
            }
            catch { }
        });

        element.addEventListener('shown.bs.modal', (evt) => {
            DEBUG && console.log('Modal now Shown');
            var groupModalBody = document.getElementById('groupFocusModal-Body');
            var groupModalMeta = document.getElementById('groupFocusModal-Meta');
            var modalHeight = groupModalBody.offsetHeight;

            groupModalMeta.style.marginTop = `-${modalHeight * .85}px`;
        });
    }


    //
    // Data: GetGroups
    //
    static async GetGroups(congregationId) {
        var data = await api.getData(`Group/GetGroupSearchModels?congregationId=${congregationId}`);
        DEBUG && console.info(data);
        return data;
    }


    //
    // Data: GetGroupTags
    //
    static async GetGroupTags(congregationId) {
        var data = await api.getData(`Group/GetGroupTags?congregationId=${congregationId}`);
        DEBUG && console.info(data);
        return data;
    }


    //
    // Data: GetGroup (single)
    //
    static async GetGroup(groupId) {
        var data = await api.getData(`Group/GetGroup?groupId=${groupId}`);
        DEBUG && console.info('==========================================');
        DEBUG && console.info('**-> Data from GetGroup');
        DEBUG && console.info(data);
        DEBUG && console.info('==========================================');
        return data;
    }


    //
    // Data: Check Group for Participation
    //
    static CheckGroupParticipant(groupId) {
        var data = api.getAuthenticatedData(`Group/CheckGroupParticipant?groupId=${groupId}`)
            .then(data => {
                DEBUG && console.info('==========================================');
                DEBUG && console.info('**-> Data from CheckGroupParticipant');
                DEBUG && console.info(data);
                DEBUG && console.info('==========================================');
                return data;
            });
    }


    //
    // DOM: LoadGroupModal
    //
    static async LoadGroupModal(groupId, manualModalOpen) {

        let that = this;

        // Replace the Group Sign Up Button by Cloning
        const oldGroupSignUpBtnElement = document.getElementById("btnGroupSignUp");
        const newGroupSignUpBtnElement = oldGroupSignUpBtnElement.cloneNode(true);
        oldGroupSignUpBtnElement.parentNode.replaceChild(newGroupSignUpBtnElement, oldGroupSignUpBtnElement);

        // Proceed to open the Modal
        DEBUG && console.info('*--> Load Group Modal for GroupID:' + groupId);

        var container = document.getElementById('groupFocusModalTemplateData');
        var groupDay = document.getElementById('groupFocusModal-groupDay');
        var groupTime = document.getElementById('groupFocusModal-groupTime');
        var groupType = document.getElementById('groupFocusModal-groupType');
        
        var groupModalLabel = document.getElementById('groupFocusModalLabel');
        var groupModalSubLabel = document.getElementById('groupFocusModalSubLabel');
        var groupModalMeta = document.getElementById('groupFocusModal-Meta');
        var groupModalBody = document.getElementById('groupFocusModal-Body');

        const groupLoginBtn = document.getElementById("btnGroupLogin");
        const groupSignUpBtn = document.getElementById('btnGroupSignUp');

        var group = await GroupsModule.GetGroup(groupId);      
        DEBUG && console.log(group);
        DEBUG && console.log('Load Modal Template');

        // Update Non-Templated Data
        groupDay.innerText = group._Day;
        groupTime.innerText = group._Time;
        groupType.innerText = group._Group_Focus;
        groupModalLabel.innerText = group.Group_Name;
        groupModalSubLabel.innerText = `${group._Ministry} | ${group._Congregation}`;

        var mergedTemplate = await TemplateService.GetRenderedTemplate(groupModalTemplate, group);

        container.innerHTML = mergedTemplate;

        // After Template Rendering
        const groupAlertElement = document.getElementById('groupAlerts');

        // Adjust the Metadata Top Margin

        if (manualModalOpen) {
            util.openModal('groupFocusModal');
        }

        // Add Copy Button
        const btnCopy = document.getElementById("btnCopy");
        util.addCopyUrl(btnCopy, 'groupid', groupId);

        // Check Group Closed / Full and Hide SignUp
        if (group._Status == "Group Full") {
            btnGroupSignUp.style.display = "none";
        }
        else if (group.External_Registration_Url)
        {
            // Enable the SignUp Button
            groupSignUpBtn.style.display = "block";

            // Add Click Event
            groupSignUpBtn.addEventListener("click", function () {
                // Sign Up for Group
                window.open(group.External_Registration_Url, '_blank');
            });
        }
        else {
            // Check for Authentication to Enable / Disable SignUp Button

            var userObj = util.getUserObj();

            if (!userObj) {
                // Hide SignUp
                groupSignUpBtn.style.display = "none";

                // Show Login Button                
                groupLoginBtn.style.display = "block";

                // Setup Group Login Button Click Event
                groupLoginBtn.addEventListener('click', function () {

                    var url = `${window.location.href}`;

                    // Add Login Callback Functionality
                    if (url.indexOf('?groupid') < 1) {
                        url = `${window.location.href}?groupid=${groupId}`;
                    }

                    if (url.indexOf('?') > 0) {
                        const baseUrl = url.split('?')[0];
                        url = `${baseUrl}?groupid=${groupId}`;
                    }

                    util.redirectToAuthentication(url);
                });

                // Add You must be logged in warning
                groupAlertElement.innerHTML = `<div class="alert alert-info text-white mt-2 mb-2">You must login to sign up for a group.  Please proceed to login to signup.  If you don't have an account, please click login and you can create one.</div>`;
            }
            else {
                // Check if Logged In User is already in this Group
                var pCheck = this.CheckGroupParticipant(groupId);

                // Finally Enable the SignUp Button
                groupSignUpBtn.style.display = "block";
                
                // Add Click Event
                groupSignUpBtn.addEventListener("click", function () {
                    // Sign Up for Group
                    var url = `Group/GroupSignUp?groupId=${groupId}`;

                    api.getAuthenticatedData(url)
                        .then(data => {
                            DEBUG && console.log(data);

                            // Close the Modal
                            util.closeModal('groupFocusModal');

                            // Show Success Growler
                            util.showSuccessToast('You joined the group.  Look for an email with more details.', 10000, true);
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                            // Show Error / Try Again
                            that.showErrorToast('An error occurred while signing up', 20000, true);
                        });

                });

                if (pCheck) {
                    // Show Already Part of this Group
                    groupAlertElement.innerHTML = `<div class="alert alert-info text-white mt-2 mb-2">You are already part of this group.  No need to sign up again.</div>`;
                    groupSignUpBtn.style.display = "none";
                }
            }
        }
    }


    //
    // Liquid Init
    //
    static GetEngine() {
        this.engine = new Liquid({
            root: '/assets/js/dist/templates',
            extname: '.html'          // extension used for layouts/includes (.html) templates
        });

        return this.engine;
    }
}


